module.exports = __webpack_public_path__ + "static/media/computer.622bed34.png";